export class Widget {
  id: number;
  name: string;
  title?: string;
  config: {
    id?: number,
    cols: number,
    rows: number,
    x?: number | undefined,
    y?: number | undefined,
  };
  type: string;
  configurable?: boolean;
  metadata: any;
  widget?: any;
  hovered?: boolean;
}

// tslint:disable-next-line:max-classes-per-file
export class WidgetGroup{
  id: number;
  name: string;
  icon: string;
  widgets: Widget[];

  constructor(widget?){
    const item = widget || {};
    this.name = item.name || '';
    this.widgets = [];
    if (widget){
      this.widgets.push(item);
    }
  }
}
